import Api from "repository/Api";
import jwtDecode from "jwt-decode";
import Cookies from "js-cookie";
import Config from "../config";

export const getUser = async (userId) => {
    const res = await Api.get(`/users/${userId}`);
    return res.data
};

export const getUserStats = async () => {
    const res = await Api.get("/user/stats");
    return res.data;
};

export const getUserSubscriptions = async () => {
    const res = await Api.get("/user_subscriptions");
    return res.data["hydra:member"][0];
};

export const mercureLogin = async () => {
    const res = await Api.get("/mercure");
    return res.data.token;
};

export const getToken = async () => {
    if (Cookies.get("token")) return Cookies.get("token");
};